<template>
  <div class="bg-lightGray" style="padding-top: 100px">
    <div class="container">
      <div class="row">
        <nav area-label="breadcrumb">
          <ol class="breadcrumb" style="font-size: 14px">
            <li class="breadcrumb-item"><a href="/recruit">Home</a></li>
            <li class="breadcrumb-item">
              <a href="/recruit/client-job-dashboard">Dashboard</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Post-private-job</li>
          </ol>
        </nav>
      </div>
      <div class="row text-center mt-5 mb-0 pt-0">
        <div class="col-md-12 col-sm-12 pl-0 pl-m-3">
          <h1 class="text-left text-dark pt mob_h5 h1st1">Post Private jobs</h1>
          <p class="text-left mb-0">Exclusive job posts for inviting applications through your networks, social media, and references</p>
        </div>
      </div>

      <div class="row mt-0">
        <div class="col-md-12 col-lg-8 pl-0 pl-m-3">
          <div>
            <form ref="postJob-form">
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <div class="gap10"></div>
                <div class="row mt-0">
                  <div class="col-lg-6 pt-0 inputStyle">
                    
                  </div>
                </div>
                <div class="row mt-0">
                  <div class="col-lg-12 pt-0 inputStyle">
                    <label for="title">Job title<span style="color: red">*</span></label>
                    <v-text-field id="job_title" v-model="toPost.jobs.job_designation" type="text" placeholder="Select Title" list="designations" @input="getJobRole" outlined clearable></v-text-field>
                    <datalist id="designations">
                      <option :key="item.value" v-for="item in designations">{{ item.text }}</option>
                    </datalist>
                    <div class="job_error" v-if="!toPost.jobs.job_designation && can_post != 0">Select Job title</div>
                  </div>
                </div>
                <div class="row mt-2 form-label-group" style="display: none">
                  <div class="col-lg-6 pt-0 pb-0">
                    <label for="title">jobs role<span style="color: red">*</span></label>
                    <input list="roles" class="form-control fields" type="text" name="jobrole"/>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 form-group pt-0 inputStyle">
                    <label for="title">Job location<span style="color: red">*</span></label>
                    <v-autocomplete id="job_cities" v-model="t_city" label="Select location" :items="states" item-text="text" item-value="id" :searchable="true" @change="showSubcity" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-content>{{data.item.text}}</v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <div class="job_error" v-if="!toPost.cities.length && can_post != 0">Select Location</div>
                  </div>
                  <div class="col-lg-6 form-group inputStyle pt-0 pb-0" v-show="subCity">
                    <label for="title">Sub location</label>
                    <v-autocomplete v-model="t_location" label="Select sublocation" @change="setSublocations" :items="sublocations" item-text="text" item-value="value" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-content>{{data.item.text}}</v-list-item-content>
                        </template>
                        
                      </template>
                    </v-autocomplete>
                  </div>

                  <div class="col-lg-6 form-group inputStyle pt-0 pb-0">
                    <label for="title">Qualification<span style="color: red">*</span></label>
                    <v-autocomplete id="job_courses" v-model="t_courses" label="Select qualification" :searchable="true" item-text="text" item-value="id" @change="getBranches" :items="courses" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-content>{{data.item.text}}</v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <div class="job_error" v-if="!toPost.courses.length && can_post != 0">Select Qualification</div>
                  </div>
                  <div class="col-lg-6 form-group inputStyle pt-0 pb-0" v-show="branches.length != 0">
                    <label for="title">Branch</label>
                    <v-autocomplete v-model="t_branches" label="Select course" @input="setBranches" :searchable="true" :items="branches" item-text="text" item-value="value" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-content>{{data.item.text}}</v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
              </div>
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <h2 class="h2st1 text-left mt-2 mb-4">Salary per annum</h2>
                <div class="row form-label-group">
                  <div class="col-lg-6 inputStyle">
                    <label for="title">Minimum<span style="color: red">*</span></label>
                    <v-text-field id="salary_min" v-model="toPost.jobs.salary_range_from" type="number" placeholder=" " @keydown.space.prevent outlined></v-text-field>
                    <div class="job_error" v-if="typeof validate.response.min_salary != 'undefined' && !validate.response.min_salary.val">{{ validate.response.min_salary.msg }}</div>
                  </div>
                  <div class="col-lg-6 inputStyle">
                    <label for="title">Maximum</label>
                    <v-text-field id="salary_max" v-model="toPost.jobs.salary_range_to" type="number" placeholder=" " @keydown.space.prevent outlined></v-text-field>
                    <div class="job_error" v-if=" typeof validate.response.max_salary != 'undefined' && !validate.response.max_salary.val && toPost.jobs.salary_range_to">{{ validate.response.max_salary.msg }}</div>
                  </div>
                </div>
              </div>
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <h2 class="h2st1 text-left mt-2 mb-4">Experience</h2>
                <div class="row form-label-group">
                  <div class="col-lg-6 inputStyle" id="experience_min">
                    <label for="title">Minimum<span style="color: red">*</span></label>
                    <v-select name="experiencemin" v-model="toPost.jobs.experience_from" :items="exp" item-value="value" item-text="text" clearable outlined deletable-chips></v-select>
                    <div class="job_error" v-if="!toPost.jobs.experience_from && can_post != 0">Enter minimum experience</div>
                  </div>
                  <div class="col-lg-6 inputStyle" id="experience_max">
                    <label for="title">Maximum</label>
                    <v-select name="experiencemax" v-model="toPost.jobs.experience_to" :items="exp" item-text="text" item-value="value" clearable outlined deletable-chips></v-select>
                  </div>
                </div>
              </div>
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <div class="row form-label-group mt-0">
                  <div class="col-lg-6 pb-0 inputStyle">
                    <label class="fz">Job type<span style="color: red">*</span></label>
                    <v-select id="job_type" v-model="default_type" label="Select type" height="55px" name="jobtype" :items="job_type" item-value="value" item-text="text" clearable outlined chips @change="setJobType"></v-select>
                    <div class="job_error" style="margin-top: -25px; margin-bottom: 12px" v-if="!toPost.jobs.job_type && can_post != 0">Select Job type</div>
                  </div>
                  <div class="col-lg-6 inputStyle pb-0">
                    <label class="fz">Hiring Process<span style="color: red">*</span></label>
                    <v-select id="hire_process" name="hireprocess" label="Select hiring process" v-model="default_hiring" :items="hire_process" item-text="text" item-value="text" @change="setHiringProcess" clearable chips outlined multiple deletable-chips></v-select>
                    <div class="job_error" style="margin-top: -25px" v-if="!toPost.jobs.hiring_process.length && can_post != 0"> Select Hiring process</div>
                  </div>
                </div>
                <div class="row form-label-group mt-6">
                  <div class="col-lg-12 inputStyle2">
                    <label for="title">Job description<span style="color: red">*</span></label>
                    <vue-editor id="job_desc" v-model="toPost.jobs.job_description" placeholder="Write a detailed job description with clear job responsibilities, expectations, criteria, and compensation details etc in simple language.Job posts with detailed Job descriptions of more than 200 characters attract more matching applications. " class="editor" @input="validate.checkIfEmpty(toPost.jobs.job_description,'description','Enter Description')"></vue-editor>
                      <div class="job_error" v-if=" typeof validate.response.description != undefined && can_post != 0">{{ validate.response.description.msg }}</div>
                  </div>
                </div>
              </div>
              <div class="morinfobtn text-right">
                <button type="button" @click="addMore()" class="btn btn-outline-primary">
                  <span v-show="!moreInfo"> + </span><span v-show="moreInfo">- </span>Additional information
                </button>
              </div>

              <div id="myDIV" style="display: block" v-show="moreInfo">
                <div class="mb-7 p-4 bg-white boxRadius">
                  <h2 class="h2st1 text-left mt-2 mb-4">More information</h2>
                  <div class="row inputStyle mt-4">
                    <div class="col-lg-6">
                      <label class="fz">No of vaccancies</label>
                      <v-text-field v-model="toPost.jobs.number_of_vacancy" type="number"  name="vaccancies" placeholder=" " @keydown.space.prevent outlined></v-text-field>
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Highest qualification mark</label>
                      <v-text-field  v-model="toPost.jobs.hq_marks_percentage_from" type="number" min="0" name="hqmark" placeholder=" " @keydown.space.prevent outlined></v-text-field>
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row inputStyle">
                    <div class="col-lg-6">
                      <label class="fz">Year of passing (From)</label>
                      <v-autocomplete v-model="toPost.jobs.year_of_passing_from" name="passout" :items="years" item-value="value" item-text="text" outlined></v-autocomplete>
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Year of passing (To)</label>
                      <v-autocomplete v-model="toPost.jobs.year_of_passing_to" name="passout" :items="years" item-value="value" item-text="text" outlined></v-autocomplete>
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row inputStyle form-label-group">
                    <div class="col-lg-6">
                      <label class="fz">Skills required</label>
                      <v-select v-model="t_skills" :searchable="true" @input="setSkills" :items="skills" item-text="text" item-value="value" clearable chips outlined multiple deletable-chips></v-select>
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Gender</label>
                      <v-select v-model="toPost.jobs.gender" name="gender" :items="gender" item-value="value" item-text="text" clearable outlined deletable-chips></v-select>
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row inputStyle mt-4">
                    <div class="col-lg-6">
                      <label class="fz">Last date of Application / Interview</label>
                      <v-text-field v-model="toPost.jobs.last_date" type="date" name="lastdate" outlined></v-text-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <div class="row inputStyle mt-4">
                  <div class="col-lg-6">
                    <label class="fz">Header Image</label>
                    <v-file-input prepend-icon="mdi-camera" accept="image/*" v-model="header_img" @change="uploadToS3(header_img,'image','header_img')" name="header_img" outlined></v-file-input>
                    <span v-if="toPost.job_custom.header_img" class="small-text">{{$S3_bucket_url + toPost.job_custom.header_img}}</span>
                    <!-- <v-progress-linear :value="header_img_progress" v-if="header_img && header_img_progress !== 100" color="light-blue" height="10" striped></v-progress-linear> -->
                  </div>
                  <div class="col-lg-6">
                    <label class="fz">Form Image</label>
                    <v-file-input prepend-icon="mdi-camera" accept="image/*" v-model="form_img" @change="uploadToS3(form_img,'image','form_img')" name="form_img" outlined></v-file-input>
                    <span v-if="toPost.job_custom.form_img" class="small-text">{{$S3_bucket_url + toPost.job_custom.form_img}}</span>
                    <!-- <v-progress-linear :value="form_img_progress" v-if="form_img && form_img_progress !== 100" color="light-blue" height="10" striped></v-progress-linear> -->
                  </div>
                </div>
                <div class="row inputStyle mt-4">
                  <div class="col-lg-6">
                    <label class="fz">Job Video</label>
                    <v-file-input accept="video/*" v-model="job_video" name="job_video" @change="uploadToS3(job_video,'video','job_video')" outlined></v-file-input>
                    <span v-if="toPost.job_custom.job_video" class="small-text">{{$S3_bucket_url + toPost.job_custom.job_video}}</span>
                    <!-- <v-progress-linear :value="job_video_progress" v-if="job_video && job_video_progress !== 100" color="light-blue" height="10" striped></v-progress-linear> -->
                  </div>
                  <div class="col-lg-6">
                    <label class="fz">Pdf</label>
                    <v-file-input accept="application/pdf" v-model="job_desc_pdf" name="job_desc_pdf" @change="uploadToS3(job_desc_pdf,'pdf','pdf')" outlined></v-file-input>
                    <span v-if="toPost.job_custom.job_desc_pdf" class="small-text">{{$S3_bucket_url + toPost.job_custom.job_desc_pdf}}</span>
                    <!-- <v-progress-linear :value="pdf_progress" v-if="job_desc_pdf && pdf_progress !== 100" color="light-blue" height="10" striped></v-progress-linear> -->
                  </div>
                </div>
                <div class="row inputStyle mt-4">
                  <div class="col-lg-12">
                    <label class="fz">Marquee Text</label>
                    <v-text-field id="job_company" class="fields" v-model="toPost.job_custom.marquee_text" type="text" name="marquee_text" outlined></v-text-field>
                  </div>
                </div>
              </div>
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <div class="row inputStyle mt-4">
                  <div class="col-lg-12">
                    <label class="fz">Company name<span style="color: red">*</span></label>
                    <v-text-field id="job_company" class=" fields" v-model="toPost.jobs.company_name" type="text" name="cname" outlined></v-text-field>
                    <div class="job_error" v-if="!toPost.jobs.company_name && can_post != 0">Enter Company</div>
                  </div>
                </div>

                <div style="height: 30px"></div>
                <div class="gap20"></div>
                <div class="form-group">
                  <input type="checkbox" name="acceptterms" checked="checked" required=""/>I accept Hireclap
                  <a class="text-decoration-none" href="/privacy">privacy policy</a>&amp;<a class="text-decoration-none" href="/terms">terms &amp; conditions *</a><br />
                  <div class="gap20"></div>
                  <p><span class="text-danger">⚠</span> Asking jobs seeker for any kind of payment is strictly prohibited.</p>
                </div>
                <div class="gap20"></div>
                <div class="row form-group">
                  <div class="col-lg-12">
                    <button class="btn btn-primary" type="submit" @click="postJob" v-if="!isPosting&&isUploading == 0" :disabled="high_usage && is_login"> &nbsp; Post job &nbsp;</button>
                    <button class="btn btn-outline-primary" v-if="isPosting&&!isUploading == 0">&nbsp; Posting... &nbsp;</button>
                    <button class="btn btn-outline-primary" v-if="isUploading > 0" disabled>&nbsp; Posting... &nbsp;</button>
                    <div class="job_error" v-if="post_error">Error in some fields, please scroll up, correct & resubmit</div>
                    <div class="job_error" v-if="upload_error">{{upload_error}}</div>
                  </div>
                </div>
              </div>
            </form>
            <div class="mb-7 p-4 bg-white boxRadius2 shadow2 faq">
            <h5>Private Job Posting - Frequently Asked Questions</h5>

            <div class="question expnd" v-b-toggle.collapse-a>What is a Private Job?</div>
            <b-collapse id="collapse-a" class="answer">
              <p>A Private Job is a unique opportunity for companies to create job postings that are exclusive to them and not publicly listed on Hireclap.com. Here's how it works:</p>
              <ul>
                <li><strong>Exclusive & private:</strong> These jobs are kept private, meaning they won't appear in the public listings on Hireclap.com. Instead, you can share them directly with your network, on social media, or through personal referrals.</li>
                <li><strong>Beyond Google Forms:</strong> Ditch the standard forms for a more personalized application process. Our custom forms let you gather exactly the information you need from candidates.</li>
                <li><strong>Microsite Branding:</strong> Enhance your job posting with a microsite. This dedicated space allows you to brand your job opportunity, making it stand out to potential applicants.</li>
                <li><strong>Application Dashboard:</strong> All applications are easily accessible through a dedicated dashboard, streamlining the process of finding your next great hire.</li>
              </ul>
              <p>Create a Private Job today and connect with candidates in a more personal and professional way.</p>
            </b-collapse>

            <div class="question expnd" v-b-toggle.collapse-b>Can I share a Hireclap Private Job link on LinkedIn instead of a Google Form?</div>
            <b-collapse id="collapse-b" class="answer">
              <p>Absolutely! Switching to a Hireclap Private Job link not only elevates the professionalism of your job postings but also centralizes your application tracking.</p>
              <p>Our customizable forms allow you to capture all candidate details that matter to you. Share your unique job post link on LinkedIn, distribute it via email, or pass it along for employee referrals with ease.</p>
              <p>Say goodbye to disjointed processes and hello to a streamlined, sophisticated hiring experience.</p>
            </b-collapse>

            <div class="question expnd" v-b-toggle.collapse-c>How can I post a 'Private Job' on Hireclap?</div>
            <b-collapse id="collapse-c" class="answer">
              <p>Simply select the 'Private Job' link in the Manage jobs / Accounts section. Fill in the job details as you would for a regular job post. To enhance your posting, you can also add banner images and videos to make it stand out.</p>
            </b-collapse>

            <div class="question expnd" v-b-toggle.collapse-d>How can I make my 'Private Job' posting stand out?</div>
            <b-collapse id="collapse-d" class="answer">
              <p>Ensure your job description is clear and detailed, and highlights the unique aspects of the role and your company. Additionally, you can add apt banner images and videos to make the job stand out. Using the custom microsite feature can also help enhance your branding.</p>
            </b-collapse>

            <div class="question expnd" v-b-toggle.collapse-e>Who can see my 'Private Job' posting?</div>
            <b-collapse id="collapse-e" class="answer">
              <p>Your 'Private Job' posting is viewable by anyone with whom you share the private job link. It will not be publicly listed on Hireclap.com.</p>
            </b-collapse>

            <div class="question expnd" v-b-toggle.collapse-f>Can I track how many applications to my 'Private Job' posting?</div>
            <b-collapse id="collapse-f" class="answer">
              <p>Yes, you can track the number of applications for your 'Private Job' through your Hireclap Manage job dashboard.</p>
            </b-collapse>

          </div>

          </div>
        </div>
        <div class="col-lg-4 col-md-4 rightarea">
          <div class="mb-7 p-4 bg-white boxRadius2 font-small">
            <div>
              <div v-if="is_login">
                <p v-if="high_usage"> We have found higher usage in your account.For security reasons we are deactivating your package.If this usage from your side, please contact admin at <a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a> to activate your package</p>
              </div>
              <h6 class="mb-2"><strong>What is a Private Job?</strong></h6>
              <ul class="listStyle1">
                <li>Exclusive job private to you.</li>
                <li>This job is not published on Hireclap.com.</li>
                <li>Replace Google form with private job.</li>
                <li>Custom application form to collect more details.</li>
                <li>Microsite for branding the job opportunity better.</li>
                <li>Dashboard to access job applications.</li>
              </ul>
              <hr class="divider1" />
              <h6 class="mb-2"><strong>Need support?</strong></h6>
              <p>Write to<a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a><br />Call +91 9037 156 256</p>
              <hr class="divider1" />
              <h6 class="mb-2"><strong>Job posting guidelines</strong></h6>
              <p> The following guidelines will help you to post jobs that are in line with standard job posting practices.Job posting that do not meet the standards may be subject to detailed review and may require additional details from hiring company to publish.Jobs that are not convinced represent a real job, misleading contents may be removed from listing.</p>
              <p> Please note the below guidelines, not a comprehensive list of what is allowable or forbidden.</p>
              <ul class="listStyle2">
                <li>Post only real and active job opportunities</li>
                <li>Use a proper job title & detailed job description</li>
                <li> Mention the eligibility criteria ,responsibilities, hiring locations</li>
                <li>Suggest to mention compensation and other benefits</li>
                <li>Donot post jobs that is not yours</li>
                <li>Donot post any in inapproappriate / offensive content</li>
                <li>Donot post jobs asking for payment from candidates</li>
                <li>Use the applicants data only for your recruitment purposes-maintain data privacy</li>
              </ul>
              <p> If you have any doubts about these guidelines, do reach out to us at recruit@hireclap.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="job-success" ref="job-success" size="sm" title=" " body-bg-variant="primary" bod body-text-variant="light" hide-footer hide-header hide-backdrop centered>
      <div class="container text-center">Job Posted Successfully</div>
    </b-modal>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import AwsUpload from "../../utils/s3upload"
export default {
  name: "JobPost",
  components: {
    VueEditor,
  },
  beforeMount() {
    this.getDesignations();
    this.getStates();
    this.getcourse();
    this.getYears();
    this.checkForActiveJobfairs();
    this.is_login = this.$cookies.get("hire-employer") ? true : false;
    this.getSkills();
    if (this.is_login) this.getJobPostQuota();
    if (this.$route.params.id) {
      this.getJobDetails(
        this.$route.params.id,
        this.$route.params.type,
        this.$route.params.user_id
      );
    }
  },
  mounted() {
    let data = this.$cookies.get("hire-employer");
    if (data) {
      new this.$apiAction().getEmployer(data.token).then((res) => {
        if (res.error == 0) {
          this.toPost.jobs.client_user_id =
            res.data.client_users.client_user_id;
          this.toPost.jobs.posted_by_id = res.data.client_users.client_user_id;
          this.toPost.jobs.company_name = res.data.client_name;
          this.disabled = true;
        }
      });
    }
  },
  data() {
    return {
      activeJobfair: false,
      selected_jobfairs: [],
      jobfairs: [],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      validate: new this.$valid(),
      default_type: { value: 1, text: "Full time" },
      default_hiring: [{ value: 4, text: "Virtual hiring" }],
      toPost: {
        jobs: {
          client_user_id: null,
          date_of_posting: new Date(),
          job_designation: "",
          company_name: "",
          last_date: new Date(
            new Date().setDate(new Date().getDate() + 30)
          ).toLocaleDateString(),
          job_type: 1,
          hiring_process: ["Virtual Hiring"],
          job_description: "",
          priority: 1,
          seo_title: null,
          seo_description: null,
          seo_keywords: null,
          response_type: 1,
          posted_by_id: null,
          salary_range_from: "",
          salary_range_to: null,
          job_role: null,
          salary_flag: 0,
          hq_marks_percentage_from: null,
          number_of_vacancy: null,
          experience_from: null,
          experience_to: null,
          year_of_passing_from: null,
          year_of_passing_to: null,
        },
        job_custom: {
          organic_status: 1,
          mode: 1,
          job_fair_display: 1,
          src: null,
          type:2,
          header_img:null,
          form_img:null,
          job_video:null,
          marquee_text:null,
          job_desc_pdf:null
        },
        courses: [],
        cities: [],
        branches: [],
        categories: [],
        skills: [],
        sublocations: [],
      },
      t_city: null,
      t_location: null,
      t_cities: [],
      t_courses: [],
      t_branches: [],
      t_skills: [],
      city: [],
      moreInfo: false,
      designations: [],
      subCity: false,
      sublocations: [],
      post_job: false,
      metro_cities: [],
      states: [],
      courses: [],
      branches: [],
      skills: [],
      user_login: false,
      registered: false,
      disabled: false,
      can_post: 0,
      exp: [
        { value: 1, text: "0 Month(Fresher)" },
        { value: 6, text: "06 Months" },
        { value: 12, text: "1 Year" },
        { value: 24, text: "2 year" },
        { value: 36, text: "3 year" },
        { value: 48, text: "4 year" },
        { value: 60, text: "5 year" },
        { value: 72, text: "6 year" },
        { value: 84, text: "6+ year" },
      ],
      gender: [
        { value: 1, text: "Male" },
        { value: 2, text: "Female" },
        { value: 3, text: "Both" },
      ],
      hire_process: [
        { value: 1, text: "Face to Face" },
        { value: 2, text: "Online assessment" },
        { value: 3, text: "Telephonic" },
        { value: 4, text: "Virtual hiring" },
        { value: 5, text: "Walk In" },
        { value: 6, text: "Written Test" },
      ],
      job_type: [
        { value: 1, text: "Full time" },
        { value: 2, text: "Work from home" },
        { value: 3, text: "Hybrid" },
        { value: 4, text: "Part time" },
        { value: 5, text: "Internship" },
        { value: 6, text: "Apprenticeship" },
      ],
      high_usage: false,
      jobDetails: null,
      job: null,
      is_login: false,
      notRegistered: false,
      password_error_msg: "",
      password_error: false,
      mobile_error: false,
      upload_error: "",
      mob_msg: "",
      acctype: {
        options: [
          { value: 1, text: "Employer" },
          { value: 2, text: "Consultant" },
          { value: 3, text: "Individual" }
        ],
      },
      isPosting: false,
      job_post_remaining: 0,
      readmore: false,
      post_error: false,
      show:true,
      years:[],
      header_img_progress:0,
      form_img_progress:0,
      job_video_progress:0,
      pdf_progress:0,
      header_img:null,
      form_img:null,
      job_video:null,
      job_desc_pdf:null,
      isUploading:0,
    };
  },
  methods: {
    checkForActiveJobfairs: function () {
      new this.$apiAction()
        .activeJobfairExists()
        .then((res) => {
          console.log("active jobfairs", res);
          if (res.status == true) {
            this.activeJobfair = true;
            this.toPost.job_custom.job_fair_display = 3;
            this.getJobfairs();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getYears(){
      var year = new Date().getFullYear();
      for(var i = year-30; i <year; i++){
        this.years.push({value:i, text:i});
      }
      for(i = year; i<=year+1; i++){
        this.years.push({value:i, text:i});
      }
    },
    getJobfairs: function () {
      // let token = this.$cookies.get("hire-employer").token;
      new this.$apiAction()
        .getJobfairs()
        .then((res) => {
          console.log("jobfairs", res);
          if (res.status == true) {
            res.jobfairs.forEach((element) => {
              {
                this.jobfairs.push({
                  text: element.job_fair_name,
                  id: element.id,
                });
              }
            })
          }else{
            this.toPost.jobs.job_role = 30;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openModal: function (type = "") {
      this.open = type == "" ? this.open : type;
      if (this.open == "success") {
        this.$refs["job-success"].show();
      }
    },
    getDesignations: function () {
      this.designations = [];
      new this.$apiAction().getJobDesignations().then((res) => {
        res.jobdesignations.forEach((e) => {
          this.designations.push({
            value: e.designation_id,
            text: e.designation,
            role_id: e.role_id,
          });
        });
      });
    },
    getJobPostQuota: function () {
      var token = this.$cookies.get("hire-employer").token;
      new this.$apiAction()
        .getFeatureQuota(process.env.VUE_APP_JOB_POST_FEATURE_ID, token)
        .then((res) => {
          if (res.status) {
            this.high_usage = res.high_usage;
            this.job_post_remaining = res.remaining_total;
          }
        });
    },
    getJobRole: function () {
      // console.log(this.toPost.jobs.job_designation);
      var flag = 0;
      this.designations.forEach((desig) => {
        if (desig.text == this.toPost.jobs.job_designation) {
          new this.$apiAction().getJobrole().then((res) => {
            res.jobroles.forEach((jobrole) => {
              if (jobrole.role_id == desig.role_id) {
                flag = flag + 1;
                this.toPost.jobs.job_role = jobrole.role_id;
              }
            });
            if (flag == 0) {
              this.toPost.jobs.job_role = 30; //set jobrole to 'others'
            }
          });
        }
      });
    },
    getStates: async function () {
      await new this.$apiAction().getStates().then(async (data) => {
        this.states.push({ header: "Top Metropolitan Cities" });
        await data.states.forEach(async (element) => {
          await element.cities.forEach((city) => {
            if (city.top_city == 1) {
              this.states.push({
                text: city.city_name,
                id: city.city_id,
                s_id: city.state_id,
                group: "Top Metropolitan Cities",
              });
            }
          });
          this.states.push({ divider: true });
          this.states.push({ header: element.state_name });
          element.cities.forEach((city) => {
            if (city.top_city == 0) {
              this.states.push({
                text: city.city_name,
                id: city.city_id,
                s_id: city.state_id,
                group: element.state_name,
              });
            }
          });
        });
        this.states.push({
          text: "Anywhere india",
          id: 5000,
          s_id: 36,
          group: "Anywhere india",
        });
      });
    },
    showSubcity: function () {
      this.subCity = false;
      this.toPost.cities = [];
      this.sublocations = [];
      this.t_city.forEach((city) => {
        this.toPost.cities.push({ city_id: city });
        this.getSubCities(city);
      });
    },
    getSubCities: function (city_id) {
      var check = true;
      new this.$apiAction().getSubcity(city_id).then((data) => {
        if (data.sublocations) {
          this.subCity = true;
          data.sublocations.forEach((element) => {
            if (check == true) {
              this.sublocations.push({
                header: element.city_name,
              });
              check = false;
            } else {
              this.sublocations.push({
                value: element.sublocation_id,
                text: element.sublocation_name,
                city_id: city_id,
              });
            }
          });
        } else if (this.sublocations.length) {
          this.subCity = true;
        } else {
          this.subCity = false;
        }
      });
    },
    setSublocations: function () {
      this.toPost.sublocations = [];
      this.t_location.forEach((data) => {
        this.toPost.sublocations.push({ sublocation_id: data });
      });
    },
    getcourse: async function () {
      await new this.$apiAction().getCourse().then(async (data) => {
        this.courses.push({ header: "Popular Courses" });
        await data.courses.forEach((element) => {
          if (
            (element.popular_rating == 1 &&
              element.course_id <= 5001 &&
              element.course_id != 37) ||
            (element.popular_rating == 1 && element.course_id == 5013)
          ) {
            this.courses.push({
              text: element.course_name,
              id: element.course_id,
              group: "Popular Courses",
            });
          }
        });
        this.courses.push({ divider: true });
        this.courses.push({ header: "PG Courses" });
        await data.courses.forEach((element) => {
          if (
            (element.popular_rating == 0 &&
              element.course_type == "pg" &&
              element.course_id <= 5001 &&
              element.course_id != 37) ||
            (element.popular_rating == 0 &&
              element.course_type == "pg" &&
              element.course_id == 5013)
          ) {
            this.courses.push({
              text: element.course_name,
              id: element.course_id,
              group: "PG Courses",
            });
          }
        });
        this.courses.push({ divider: true });
        this.courses.push({ header: "Graduation Courses" });
        await data.courses.forEach((element) => {
          if (
            (element.popular_rating == 0 &&
              element.course_type == "graduation" &&
              element.course_id <= 5001 &&
              element.course_id != 37) ||
            (element.popular_rating == 0 &&
              element.course_type == "graduation" &&
              element.course_id == 5013)
          ) {
            this.courses.push({
              text: element.course_name,
              id: element.course_id,
              group: "Graduation Courses",
            });
          }
        });
        this.courses.push({ divider: true });
        this.courses.push({ header: "Other Category" });
        await data.courses.forEach((element) => {
          if (
            (element.popular_rating == 0 &&
              element.course_type == "others_category" &&
              element.course_id <= 5001 &&
              element.course_id != 37) ||
            (element.popular_rating == 0 &&
              element.course_type == "others_category" &&
              element.course_id == 5013)
          ) {
            this.courses.push({
              text: element.course_name,
              id: element.course_id,
              group: "Other Category",
            });
          }
        });
      });
    },
    getBranches: function () {
      this.branches = [];
      this.toPost.courses = [];
      var check = true;
      this.t_courses.forEach((data) => {
        this.toPost.courses.push({ course_id: data });
      });
      this.toPost.courses.forEach((course) => {
        new this.$apiAction().getSpec(course.course_id).then((data) => {
          check = true;
          if (data.specifications) {
            data.specifications.forEach((element) => {
              if (check == true) {
                this.branches.push({
                  header: element.course_name,
                });
                this.branches.push({
                  value: element.bid,
                  text: element.branch_name,
                });
                check = false;
              } else {
                this.branches.push({
                  value: element.bid,
                  text: element.branch_name,
                });
              }
            });
          }
        });
      });
    },
    setBranches: function () {
      this.toPost.branches = [];
      this.t_branches.forEach((branch) => {
        this.toPost.branches.push({ branch_id: branch });
      });
    },
    setJobType: function () {
      if (this.default_type) {
        this.toPost.jobs.job_type = this.default_type;
      } else {
        this.toPost.jobs.job_type = "";
      }
    },
    setHiringProcess: function () {
      this.toPost.jobs.hiring_process = this.default_hiring;
    },
    hideSalary: function (e) {
      this.toPost.jobs.salary_flag = e.target.checked ? 1 : 0;
    },
    addMore: function () {
      this.moreInfo = !this.moreInfo;
    },
    getSkills: function () {
      this.skills = [];
      new this.$apiAction()
        .getSkills()
        .then((data) => {
          data.skills.forEach((element) => {
            this.skills.push({
              value: element.id,
              text: element.skill,
              slug: element.slug,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setSkills: function () {
      this.toPost.skills = [];
      this.t_skills.forEach((skill) => {
        this.toPost.skills.push({ skills_id: skill });
      });
    },
    async uploadToS3(file,type,field_name){
      this.upload_error = '';
      // this.isUploading = false;
      if(file){
        this.isUploading++;
        const awsUploader = new AwsUpload();
        try {
          var extension = file.name.split('.')[file.name.split('.').length-1]
          var d = new Date();
          var month = d.getMonth() + 1;
          var day = d.getDate();
          var current_date =d.getFullYear() +"/" +(month < 10 ? "0" : "") +month +"/" +(day < 10 ? "0" : "") +day;
          var timestamp = Math.floor(Date.now() / 1000);
          var filename = 'job/'+ field_name+"/"+current_date+'/'+ timestamp + "."+extension
          const response = await awsUploader.uploadImage(file, filename);
          if(response){
            this.isUploading--;
            switch(field_name) {
              case 'header_img': this.toPost.job_custom.header_img= response.url; break;
              case 'form_img': this.toPost.job_custom.form_img =response.url; break;
              case 'job_video': this.toPost.job_custom.job_video = response.url; break;
              case 'pdf': this.toPost.job_custom.job_desc_pdf = response.url; break;
              default: break;
            }
            return true;
          }
        } catch (error) {
          this.isUploading--;
          this.upload_error = "Something wrong with the " + type + " upload. Please try again"
          return false;
        }
      }
    },
    postJob: async function (e) {
      e.preventDefault();
      if (this.is_login && this.high_usage) return false;
      var city = null;
      this.can_post = 0;
      this.post_error = false;
      this.isPosting = true;
      var scrolledY;
      if (!this.toPost.jobs.job_designation) {
        this.can_post++;
      }
      if (this.toPost.cities.length == 0) {
        this.can_post++;
      }
      if (this.toPost.courses.length == 0) {
        this.can_post++;
      }
      if(this.validate.salaryValidation(this.toPost.jobs.salary_range_from, "min_salary")?.val === false){
        this.can_post++;
      }
      if(this.validate.salaryValidation(this.toPost.jobs.salary_range_to, "max_salary")?.val === false && this.toPost.jobs.salary_range_to){
        this.can_post++;
      }
      if(!this.toPost.jobs.experience_from){
        this.can_post++;
      }
      if (!this.toPost.jobs.job_type) {
        this.can_post++;
      }
      if (this.toPost.jobs.hiring_process.length == 0) {
        this.can_post++;
      }
      if (this.validate.checkIfEmpty(this.toPost.jobs.job_description,"description","Enter Description")?.val === false) {
        this.can_post++;
      }
      if (this.toPost.jobs.company_name == "") {
        this.can_post++;
      }
      if (this.can_post === 0) {
        this.states.forEach((data) => {
          if (data.id && data.id == this.toPost.cities[0]?.city_id) {
            city = data.text;
          }
        });
        this.toPost.job_custom.src = this.$route.query.src ? this.$route.query.src: "home-post";
        var s_description = this.toPost.jobs.job_description ? this.toPost.jobs.job_description.replace(/(<([^>]+)>)/gi, "") : "";
        this.toPost.jobs.seo_title = this.toPost.jobs.job_designation + " jobs in " + city + " - " + this.toPost.jobs.company_name;
        this.toPost.jobs.seo_description = (this.toPost.jobs.job_designation +" jobs in " +city +" - " +this.toPost.jobs.company_name +" - " +s_description).substr(0, 200);
        this.toPost.jobs.seo_keywords = [this.toPost.jobs.job_designation,city,this.toPost.jobs.company_name].join();
        this.toPost.jobs.hiring_process = this.toPost.jobs.hiring_process && typeof this.toPost.jobs.hiring_process != "string"? this.toPost.jobs.hiring_process.join(): typeof this.toPost.jobs.hiring_process == "string"? this.toPost.jobs.hiring_process: null;
        // this.toPost.jobs.year_of_passing_from = this.toPost.jobs .year_of_passing_from ? this.toPost.jobs.year_of_passing_from.split("-")[0] : null;
        // this.toPost.jobs.year_of_passing_to = this.toPost.jobs .year_of_passing_to ? this.toPost.jobs.year_of_passing_to.split("-")[0] : null;
        this.toPost.jobs.salary_range_to = this.toPost.jobs.salary_range_to ? this.toPost.jobs.salary_range_to : null;
        if (this.toPost.jobs.experience_from == 1) {
          this.toPost.jobs.experience_from = 0;
        }
        if (this.toPost.jobs.experience_to == 1) {
          this.toPost.jobs.experience_to = 0;
        }

        console.log(this.header_img , this.form_img , this.job_video , this.job_desc_pdf);
        let token = this.$cookies.get("hire-employer").token;
        // if(this.header_img || this.form_img || this.job_video || this.job_desc_pdf){
        //   this.$refs['upload_progress'].show();

        //   if(this.header_img){
        //     await this.uploadToS3(this.header_img,'image','header_img');
        //   }
        //   if(this.form_img){
        //     await this.uploadToS3(this.form_img,'image','form_img');
        //   }
        //   if(this.job_video){
        //     await this.uploadToS3(this.job_video,'video','job_video');
        //   }
        //   if(this.job_desc_pdf){
        //     await this.uploadToS3(this.job_desc_pdf,'pdf','pdf');
        //   }

        //   this.$refs['upload_progress'].hide();
        //   new this.$apiAction().jobPost(this.toPost, token).then((res) => {
        //   if (res.error == 0) {
        //     this.isPosting = false;
        //     // this.job_post_remaining = res.remaining_total;
            
        //         // console.log(res.)
        //         // if(this.selected_jobfairs.length > 0){
        //         //   this.addJobs(res.data.job_id);
        //         // } else {
        //         //   this.$router.push({name:'questionnaire',params:{'status':true,id:res.data.job_id},query:{role:this.toPost.jobs.job_role,version:'draft',user:this.toPost.jobs.client_user_id}});
        //         // }
        //     }else {
        //       console.log("empty field", this.can_post,);
        //     }
        //   }).catch((err) => {
        //     this.isPosting = false;
        //     console.log(err);
        //   });
        // }else{
          new this.$apiAction().jobPost(this.toPost, token).then((res) => {
            if (res.error == 0) {
              this.isPosting = false;
              this.job_post_remaining = res.remaining_total;              
                if(this.selected_jobfairs.length > 0){
                  this.addJobs(res.data.job_id);
                } else {
                  this.$router.push({name:'questionnaire',params:{'status':true,id:res.data.job_id},query:{role:this.toPost.jobs.job_role,version:'draft',user:this.toPost.jobs.client_user_id}});
                }
              }else {
              console.log("empty field", this.can_post,);
            }
          }).catch((err) => {
            this.isPosting = false;
            console.log(err);
          });
        // }
      }else{
        this.isPosting = false;
        this.post_error = true;
        if (!this.toPost.jobs.job_designation) {
          document.getElementById('job_title').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.toPost.cities.length == 0) {
          document.getElementById('job_cities').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.toPost.courses.length == 0) {
          document.getElementById('job_courses').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if(this.validate.salaryValidation(this.toPost.jobs.salary_range_from, "min_salary")?.val === false){
          document.getElementById('salary_min').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if(this.validate.salaryValidation(this.toPost.jobs.salary_range_to, "max_salary")?.val === false && this.toPost.jobs.salary_range_to){
          document.getElementById('salary_max').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if(this.validate.checkIfEmpty(this.toPost.jobs.experience_from, "min_exp")?.val === false){
          document.getElementById('experience_min').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (!this.toPost.jobs.job_type) {
          document.getElementById('job_type').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.toPost.jobs.hiring_process.length == 0) {
          document.getElementById('hire_process').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.validate.checkIfEmpty(this.toPost.jobs.job_description,"description","Enter Description")?.val === false) {
          document.getElementById('job_desc').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.toPost.jobs.company_name == "") {
          document.getElementById('job_company').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.selected_jobfairs.length == 0 &&(this.toPost.job_custom.job_fair_display == 2 || this.toPost.job_custom.job_fair_display == 3)) {
          document.getElementById('jobfairs').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }
      }
    },
    addJobs: function(job_id, redirect = true) {
      let data = [];
      let token = this.$cookies.get("hire-employer").token;
      this.selected_jobfairs.forEach(jobfair => {
          data.push({job_fair_id: jobfair,job_id: job_id});
      });
      new this.$apiAction().addJobs(data, token).then((res) => {
        if(res.status == true ) {
          if(redirect) {
            this.$router.replace({name:'recruiter_dashboard',params:{success:'Your job has been posted successfully , it will be active within the next 24 hrs'}});
            window.scrollTo(0, 0);
            location.reload();
          } else {
            new this.$apiAction().empLogout(token).then(res => {
              if(res.status == '1'){
                this.$cookies.remove("hire-employer");
                this.$router.push({name:'rec_login',params:{success_msg:'The job has been posted successfully. You can login now.'}});
                // this.$router.push("/recruit/login");
              }
            })
          }
        }
      }).catch((err) => {
          console.log(err)
      });
    },
    getJobDetails(id,type,u_id){
      new this.$apiAction().getJobDetails({id:id,type:type, user_id:u_id}).then(res => {
        this.toPost.jobs = res.data.jobs;
        this.toPost.job_custom = res.data.job_custom;
        res.data.branches.forEach((branch) => {
          this.toPost.branches.push({ branch_id: branch });
          this.t_branches.push(branch);
        });
        res.data.cities.forEach((city) => {
          this.toPost.cities.push({ branch_id: city });
          this.t_city = { id: city, text: "malappuram" };
        });
        res.data.courses.forEach((course) => {
          this.toPost.courses.push({ course_id: course });
          this.t_courses.push({ value: course, text: "10th Pass (SSC)" });
        });
        res.data.skills.forEach((skill) => {
          this.toPost.skills.push({ branch_id: skill });
          this.t_skills.push(skill);
        });
        res.data.sublocations.forEach((subloc) => {
          this.toPost.sublocations.push({ branch_id: subloc });
          this.t_location.push(subloc);
        });
      });
    }
  }
};
</script>

<style>
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
